<form [formGroup]="profileForm" class="min-vh-79 h-100 w-100">
  <div class="card min-vh-79 h-100 personal-information-container">
    <div class="card-body row">
      <!-- Profile Photo -->
      <div class="col-md-4 text-center border rounded-2 p-4 shadow-sm" id="profile-photo-container" style="max-height: max-content">
        <img [src]="profilePictureSrc" class="img-fluid rounded-circle mb-3" style="max-width: 150px;" alt="Profile pic">
        <p class="small text-muted mb-4">JPG or PNG <br> Max size of 800K</p>

        <div class="d-flex flex-column align-items-center gap-3 w-100">
          <label for="photoUpload"
                 class="text-primary d-flex align-items-center gap-1 fw-medium"
                 style="cursor: pointer;">
            <mat-icon style="font-size: 20px;">upload</mat-icon>
            Change Photo
          </label>
          <input type="file" maxlength="1" [accept]="IMAGE_ACCEPT_FORMATS"
                 class="d-none" id="photoUpload" (change)="onPhotoUpload($event)">

          <hr class="w-75 my-0">

          <button type="button"
                  class="text-danger border-0 bg-transparent d-flex align-items-center gap-1 fw-medium"
                  (click)="removePhoto()"
                  style="cursor: pointer;">
            <mat-icon style="font-size: 20px;">delete_outline</mat-icon>
            Remove
          </button>
        </div>
      </div>

      <!-- Profile Details -->
      <div class="col-md-8">
        <div class="mb-3">
          <app-personal-information-edit-card
            [type]="PersonalInformationEditCardType.NAME"
            [formGroup]="profileForm"
            [currentUserId]="currentUserId"
            [isEditing]="selectedEditCardType == PersonalInformationEditCardType.NAME"
            (onClickSave)="submit($event)"
            (onClickCancel)="resetFormToDefault()"
            (onClickEdit)="selectedEditCardType = $event"
          ></app-personal-information-edit-card>
        </div>

        <div class="mb-3">
          <app-personal-information-edit-card
            [type]="PersonalInformationEditCardType.EMAIL"
            [formGroup]="profileForm"
            [currentUserId]="currentUserId"
            [isEditing]="selectedEditCardType == PersonalInformationEditCardType.EMAIL"
            (onClickSave)="submit($event)"
            (onClickCancel)="resetFormToDefault()"
            (onClickEdit)="selectedEditCardType = $event"
          ></app-personal-information-edit-card>
        </div>

        <div class="mb-3">
          <app-personal-information-edit-card
            [type]="PersonalInformationEditCardType.PHONE"
            [formGroup]="profileForm"
            [currentUserId]="currentUserId"
            [isEditing]="selectedEditCardType == PersonalInformationEditCardType.PHONE"
            (onClickSave)="submit($event)"
            (onClickCancel)="resetFormToDefault()"
            (onClickEdit)="selectedEditCardType = $event"
          ></app-personal-information-edit-card>
        </div>

        <div class="mb-3">
          <app-personal-information-edit-card
            [type]="PersonalInformationEditCardType.PASSWORD"
            [formGroup]="profileForm"
            [currentUserId]="currentUserId"
            [isEditing]="selectedEditCardType == PersonalInformationEditCardType.PASSWORD"
            (onClickSave)="submit($event)"
            (onClickCancel)="resetFormToDefault()"
            (onClickEdit)="selectedEditCardType = $event"
          ></app-personal-information-edit-card>
        </div>
      </div>
    </div>
  </div>
</form>
